import { css } from '@emotion/core'

export const loader = css`
  display: flex;
  justify-content: center;
`
